export default __webpack_public_path__ + "static/N0039-884e21314dc4ae41910ebe6e4297d142.png";